import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from '@tanstack/react-router';
import { createOutlookDialogLogout } from 'src/features/plugins/outlook/components/auth.utils';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import { OrgProvider } from 'src/shared/contexts/OrgContext';
import { SocketProvider } from 'src/shared/contexts/SocketContext';

export default function Layout({ children }: { children: ReactNode }) {
  const { isAuthenticated, logout } = useAuth0();
  const navigate = useNavigate();
  const router = {
    push: (href: string) => navigate({ to: href }),
    replace: (href: string) => navigate({ to: href, replace: true }),
    back: () => window.history.back(),
  };
  return (
    <AuthProvider
      redirectPrefix="/plugins/outlook"
      logoutOverride={createOutlookDialogLogout(isAuthenticated, logout, router)}
    >
      <OrgProvider disableOrgBadge>
        <SocketProvider>{children}</SocketProvider>
      </OrgProvider>
    </AuthProvider>
  );
}
